// Theme tokens for the AgilityIO template
// Used by both PDF and DOCX renderers. Units are in pt

const theme = {
  colors: {
    foreground: '#353744',
    primary: '#3c78d8',
    secondary: '#666666',
    muted: '#99999b',
    background: '#ffffff',
  },

  typography: {
    fontFamily: 'Proxima Nova',
    lineHeight: 1.6,
    /** All values in pt */
    fontSize: {
      base: 11,
      lg: 14,
      '4xl': 27,
    },
  },

  spacing: {
    headerHeight: 68,
    headerPaddingTop: 30,
    footerHeight: 32,
    footerOffset: 44,
    pagePadding: 72,
    listIndent: 18,
    bulletSize: 4,
    bulletGap: 14,
    bulletOffset: 5,
    sectionGap: 10,
    sectionHeadingGap: 10,
    displayMarginTop: 5,
    displayMarginBottom: 10,
    entryGap: 10,
    entryTitleMarginTop: 8,
  },
} as const;

export default theme;

/** Section heading labels */
export const SECTION_TITLES = {
  professionalProfile: 'Professional Profile',
  technicalSkills: 'Technical Skills',
  experience: 'Project Experience',
  education: 'Education',
  certifications: 'Certifications and Courses',
} as const;

/** Footer notice text */
export const CONFIDENTIALITY_NOTICE =
  'Confidential \u2013 Provided by AgilityIO';
